module.exports = __webpack_public_path__ + "static/media/bg111.3f2ef55e.jpg";